import AircallPhone from './src/javascripts/aircallPhone.js';

export default AircallPhone;
